import { mercadonaDomain, OLD_SHOP_LANGUAGES } from '../constants'
import i18next from 'i18next'

const SELECTOR = '.o-legal'
let node

const Legal = {
  mount(currentLanguage) {
    node = document.querySelector(SELECTOR)
    this.render(currentLanguage, node)
  },

  render(currentLanguage) {
    currentLanguage = OLD_SHOP_LANGUAGES[currentLanguage]
    node.innerHTML = `
    <li>
      <a href="${mercadonaDomain}${currentLanguage}/accesibilidad">
        ${i18next.t('footer_section.accessibility')}
      </a>
    </li>
    <li>
      <a href="${mercadonaDomain}${currentLanguage}/politica-de-privacidad">
        ${i18next.t('footer_section.privacy')}
      </a>
    </li>
    <li>
      <a href="${mercadonaDomain}${currentLanguage}/politica-de-cookies">
        ${i18next.t('footer_section.cookies')}
      </a>
    </li>
    <li>
      <a href="${mercadonaDomain}${currentLanguage}/terminos-y-condiciones">
        ${i18next.t('footer_section.terms')}
      </a>
    </li>
  `
  },
}

export { Legal }
